import React, { useEffect, useState } from "react";
import styles from "./Login.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import { loginApi } from "../../api";
import PasswordShow from "../../public/images/PasswordShow.svg";
import PasswordHide from "../../public/images/PasswordHide.svg";
import queryString from "query-string";
import Button from "../../Common/Button/Button";
const Login = ({
  username: userDetails,
  handleVerifyUser,
  setStep,
  loader,
  setLoader,
  handleSuccessfulLogin,
}) => {
  const [username, setUsername] = useState(userDetails);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [credentials, setCredentials] = useState(false);
  const [passwordType, setPasswordType] = useState("password");
  const navigate = useNavigate();
  const location = useLocation();

  const validationForm = () => {
    let formErrors = {};

    if (!password) {
      formErrors.password = "Password is required";
    }
    setError(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const togglePasswordVisibility = () => {
    const type = passwordType === "password" ? "text" : "password";
    setPasswordType(type);
  };

  const handleChange = (e) => {
    setError("");
    if (e.target.placeholder === "Username") {
      setUsername(e.target.value);
    } else {
      setPassword(e.target.value);
    }
  };

  const signIn = async () => {
    setError("");
    setLoader(true);

    if (!validationForm()) {
      setLoader(false);
      return;
    }

    const data = { username, password };
    if (username && password) {
      try {
        const loginResponse = await loginApi(data);

        if (loginResponse?.data?.code === 200) {
          const authKey = loginResponse?.data?.data?.authKey;

          if (authKey) {
            handleSuccessfulLogin(authKey);
          }

          try {
            handleVerifyUser(username, "login_verification");
          } catch (error) {
            setLoader(false);
            setError(loginResponse?.data?.error || "Something went Wrong!");
          }
          setStep("step2");
        } else {
          setCredentials(false);
          setLoader(false);
          setError(loginResponse?.data?.error || "Something went Wrong!");
        }
      } catch (error) {
        setError(error.response?.data?.error || "Something went Wrong!");
        setLoader(false);
      }
    }
    setLoader(false);
  };

  useEffect(() => {
    if (credentials) {
      const { redirectTo } = queryString.parse(location.search);
      navigate(redirectTo ? decodeURIComponent(redirectTo) : "/");
    }
  }, [credentials, location.search, navigate]);

  return (
    <form>
      <label>
        Username
        <input
          type="text"
          className={styles.username}
          placeholder="Username"
          value={username}
          readOnly={true}
          onChange={handleChange}
        />
        {error.username && (
          <div className={styles.validationError}>{error.username}</div>
        )}
      </label>
      <label className={styles.labelParent}>
        Password
        <img
          alt=""
          className={styles.toggleIcon}
          src={passwordType === "password" ? PasswordHide : PasswordShow}
          onClick={togglePasswordVisibility}
        />
        <input
          type={passwordType}
          className={styles.password}
          placeholder="Password"
          value={password}
          onChange={handleChange}
        />
        {error.password && (
          <div className={styles.validationError}>{error.password}</div>
        )}
        <span
          className={styles.forgotPass}
          onClick={() => {
            navigate(`/forgot-password?email=${username}`);
          }}
        >
          forgot password?
        </span>
      </label>
      {typeof error === "string" && error.length > 0 && (
        <div className={styles.errorMessage}>{error}</div>
      )}
      <Button
        type="submit"
        loading={loader}
        handleClick={signIn}
        heading={"Sign In"}
        width="140px"
      />
    </form>
  );
};

export default Login;
